const PATH_PREFIX = '/business/:companyID';

export default [
  {
    name: 'business.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
  },
  {
    name: 'business.profile',
    path: `${PATH_PREFIX}/profile`,
  },
  {
    name: 'business.commercial_practice',
    path: `${PATH_PREFIX}/commercial_practice`,
  },
  {
    name: 'business.market_coverage',
    path: `${PATH_PREFIX}/market_coverage`,
  },
  {
    name: 'business.shipping_method.list',
    path: `${PATH_PREFIX}/shipping_methods`,
  },
  {
    name: 'business.shipping_method.detail',
    path: `${PATH_PREFIX}/shipping_method/:docID/detail`,
  },
  {
    name: 'business.payment_method.list',
    path: `${PATH_PREFIX}/payment_methods`,
  },
  {
    name: 'business.payment_method.detail',
    path: `${PATH_PREFIX}/payment_method/:docID/detail`,
  },
  {
    name: 'business.keyword.classifications',
    path: `${PATH_PREFIX}/classifications`,
  },
  {
    name: 'business.keyword.brands',
    path: `${PATH_PREFIX}/brands`,
  },
  {
    name: 'business.keyword.tags',
    path: `${PATH_PREFIX}/tags`,
  },
  {
    name: 'business.contacts',
    path: `${PATH_PREFIX}/contacts`,
  },
  {
    name: 'business.branch',
    path: `${PATH_PREFIX}/branches`,
  },
  {
    name: 'business.logo',
    path: `${PATH_PREFIX}/logo`,
  },
  {
    name: 'business.banner',
    path: `${PATH_PREFIX}/banner`,
  },
  {
    name: 'business.banner.detail',
    path: `${PATH_PREFIX}/banner/:docID`,
  },
  {
    name: 'business.advertisement',
    path: `${PATH_PREFIX}/advertisement`,
  },
  {
    name: 'business.catalogue',
    path: `${PATH_PREFIX}/catalogue`,
  },
  {
    name: 'business.departments',
    path: `${PATH_PREFIX}/departments`,
  },
  {
    name: 'business.department',
    path: `${PATH_PREFIX}/teams/departments/:docID`,
  },
  {
    name: 'business.employees',
    path: `${PATH_PREFIX}/teams/employees`,
  },
  {
    name: 'business.employee',
    path: `${PATH_PREFIX}/teams/employees/:docID`,
  },
  {
    name: 'business.page.main_page',
    path: `${PATH_PREFIX}/page/main_page`,
  },
  {
    name: 'business.setting',
    path: `${PATH_PREFIX}/setting`,
  },
];
